// Rutas del módulo notificaciones: objetos de ruta hijos del Layout (ver src/Routes.js).
const AdministracionNotificaciones = () => import('@/pages/Administracion/Notificaciones/Notificaciones.vue');

export default [
    {
        path: '/administracion/notificaciones',
        name: 'AdministracionNotificaciones',
        component: AdministracionNotificaciones,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {name: 'Inicio', href: 'Inicio'},
                {name: 'Administración', href: 'Administracion'},
                {name: 'Notificaciones'},
            ],
        },
    },
];
